import { BorderBox, ContentBox, Layout } from "./style";
import bgImage from "../../assets/images/img-bg-full-apply.jpg";
import { A, Font, Img, Row, Span } from "../../styles/commonStyle";
import { primaryColor, greenColor, modalGreyBtnColor } from "../../styles/theme";
import btnAppstore from "../../assets/images/btn-appstore.png";
import btnPlaystore from "../../assets/images/btn-playstore.png";
import { useEffect, useState } from "react";
import { isIOS, isMacOs } from "react-device-detect";
import successIcon from "../../assets/images/qr-success.png";

function QRpayResultPage() {
  const [isVisible, setIsVisible] = useState(false);
  const appStoreUrl = "https://itunes.apple.com/kr/app/evwhere/id1231333404";
  const playStoreUrl = "https://play.google.com/store/apps/details?id=com.ecoevc.evwhere.evwhere";

  useEffect(() => {
    // 페이지 로드 후 애니메이션 시작
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  const redirectToAppStore = () => {
    if (isIOS || isMacOs) {
      window.open(appStoreUrl, '_blank');
    } else {
      window.open(playStoreUrl, '_blank');
    }
  };

  return (
    <Layout image={bgImage}>
      <ContentBox paddingLeft="2rem" paddingRight="2rem" paddingTop="2rem">
        {/* 성공 상태 표시 */}
        <Row className="justify-center" style={{ 
          marginBottom: '1.5rem',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
          transition: 'all 0.6s ease-out'
        }}>
          <img src={successIcon} alt="success" />
        </Row>

        {/* 메인 제목 */}
        <Font fontSize="1.25rem" fontWeight="700" className="text-center" style={{ 
          marginBottom: '0.5rem', 
          color: '#2c3e50',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
          transition: 'all 0.6s ease-out 0.1s'
        }}>
          QR 인증이 완료되었습니다
        </Font>

        {/* 안내 메시지 */}
        <div style={{ 
          marginBottom: '2rem',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
          transition: 'all 0.6s ease-out 0.2s'
        }}>
          <Font color={modalGreyBtnColor} fontSize="1rem" fontWeight="500" className="text-center" style={{ marginBottom: '0.3rem' }}>
            <Span color={primaryColor} fontWeight="600">충전기의 안내</Span>에 따라 충전을 시작해주세요.
          </Font>
        </div>

        {/* 앱 다운로드 섹션 */}
        <BorderBox style={{ 
          padding: '1.5rem',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
          transition: 'all 0.8s ease-out 0.3s'
        }}>
          <div style={{ marginBottom: '1rem', textAlign: 'center' }}>
            <div style={{ textAlign: 'center' }}>
              <Font fontSize="1.1rem" fontWeight="500" style={{ color: '#2c3e50', textAlign: 'center', display: 'block' }}>
                <Span color={primaryColor} fontWeight="600">evWhere 앱</Span>을 설치하고
              </Font>
            </div>
            <div style={{ marginBottom: '0.8rem', textAlign: 'center' }}>
              <Font fontSize="1.1rem" fontWeight="500" style={{ color: '#2c3e50', textAlign: 'center', display: 'block' }}>
                evPlug 회원으로 가입해보세요
              </Font>
            </div>
            <div style={{ textAlign: 'center' }}>
              <Font fontSize="0.9rem" fontWeight="400" style={{ color: '#666', lineHeight: '1.5', textAlign: 'center', display: 'block' }}>
                다양한 서비스는 물론, 더 저렴한 요금으로<br />
                충전하실 수 있습니다.
              </Font>
            </div>
          </div>
          
          <Row className="justify-center w-full" style={{ gap: '0.5rem' }}>
            {/* <A href={appStoreUrl} target="_blank">
              <Img src={btnAppstore} width="160px" />
            </A>
            <A href={playStoreUrl} target="_blank">
              <Img src={btnPlaystore} width="160px" />
            </A> */}
             <button style={{ width: '100%', backgroundColor: primaryColor, color: 'white',fontWeight: '500', borderRadius: '2rem', padding: '0.5rem' }} onClick={redirectToAppStore}>앱 다운로드하기</button>
          </Row>
        </BorderBox>
      </ContentBox>
    </Layout>
  );
}
export default QRpayResultPage;
